module.exports = __webpack_public_path__ + "img/sun-and-cloud.e2d8f19d.svg";